import {ItemExplorerViewOptions} from "utils/DBUtils";

const initialState = {
    generateAfterOriginal: null,

    generatingImages: false,
    creatingImage: false,
    editingImage: false,
    pickingImage: false,

    isConfirmCancelModalOpen: false,

    // container for images' form data, whether being edited or uploaded, in bulk or not.
    pendingImages: [],
    selectedPendingImage: null,
    uploadingImagesFor: null,

    // for caching index of selectedPendingImage in pendingImages
    selectedPendingImageIndex: 0,

    // form data management state for ImageEditForm
    showImageEditFormErrors: false,
    imageEditFormErrors: {},

    pickingOriginalForResourceId: null,

    originalImageData: null,
    recentUploads: [],
    currentOriginalsPage: [],

    currentlyUploading: [],
    uploadingImage: false,
    currentResourceOriginals: [],

    selectedImage: null,
    selectedImageId: null,

    totalImages: 0,
    rowCount: 2,
    colCount: 4,
    currentPage: 0,
    currentPageSize: 10,
    imagesPageSize: 10,

    selectedImageSiblings: [],

    createAfterOriginal: null,
    creatingImageFor: null,
    savingImageData: false,

    // context for the native (non-Filestack) upload modal; non-null while it's open.
    nativeUploadContext: null,

    // context for the native (non-Filestack) re-crop modal (§10's "Edit Image" path);
    // non-null while it's open. Mutually exclusive with nativeUploadContext in practice
    // (only one of the two modals is ever open at a time), but kept as its own field
    // rather than reusing nativeUploadContext since the two modals have different shapes
    // (this one carries originalImageId, not a freshly picked source).
    nativeRecropContext: null,

    selectedView: ItemExplorerViewOptions.List
};

export default initialState;



// WEBPACK FOOTER //
// ./public/pages/Images/initialState.js